module.exports = __webpack_public_path__ + "overcast_podcasts-c1d43e3bb674241c95b8.svg";